var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerLight40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2632_34302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C20.6904 0 21.25 0.559644 21.25 1.25V10C21.25 10.6904 20.6904 11.25 20 11.25C19.3096 11.25 18.75 10.6904 18.75 10V1.25C18.75 0.559644 19.3096 0 20 0Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 28.75C20.6904 28.75 21.25 29.3096 21.25 30V38.75C21.25 39.4404 20.6904 40 20 40C19.3096 40 18.75 39.4404 18.75 38.75V30C18.75 29.3096 19.3096 28.75 20 28.75Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0002 2.67943C30.5981 3.0246 30.8029 3.78909 30.4577 4.38696L26.0827 11.9647C25.7376 12.5625 24.9731 12.7674 24.3752 12.4222C23.7773 12.077 23.5725 11.3125 23.9177 10.7147L28.2927 3.13696C28.6379 2.53909 29.4023 2.33425 30.0002 2.67943Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6252 27.5777C16.2231 27.9228 16.4279 28.6873 16.0827 29.2852L11.7077 36.8629C11.3626 37.4608 10.5981 37.6656 10.0002 37.3204C9.40234 36.9753 9.1975 36.2108 9.54268 35.6129L13.9177 28.0352C14.2629 27.4373 15.0273 27.2325 15.6252 27.5777Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3226 10.0001C37.6678 10.5979 37.4629 11.3624 36.865 11.7076L29.2873 16.0826C28.6895 16.4278 27.925 16.2229 27.5798 15.6251C27.2346 15.0272 27.4395 14.2627 28.0373 13.9175L35.615 9.54252C36.2129 9.19735 36.9774 9.40219 37.3226 10.0001Z",
    fill: "#000001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4202 24.3751C12.7654 24.9729 12.5606 25.7374 11.9627 26.0826L4.38497 30.4576C3.78711 30.8028 3.02262 30.5979 2.67744 30.0001C2.33226 29.4022 2.53711 28.6377 3.13497 28.2925L10.7127 23.9175C11.3106 23.5723 12.0751 23.7772 12.4202 24.3751Z",
    fill: "#000001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.75 20C28.75 19.3096 29.3096 18.75 30 18.75H38.75C39.4404 18.75 40 19.3096 40 20C40 20.6904 39.4404 21.25 38.75 21.25H30C29.3096 21.25 28.75 20.6904 28.75 20Z",
    fill: "#000001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 19.3096 0.559644 18.75 1.25 18.75H10C10.6904 18.75 11.25 19.3096 11.25 20C11.25 20.6904 10.6904 21.25 10 21.25H1.25C0.559644 21.25 0 20.6904 0 20Z",
    fill: "#000001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5798 24.3751C27.925 23.7772 28.6895 23.5723 29.2873 23.9175L36.865 28.2925C37.4629 28.6377 37.6678 29.4022 37.3226 30.0001C36.9774 30.5979 36.2129 30.8028 35.615 30.4576L28.0373 26.0826C27.4395 25.7374 27.2346 24.9729 27.5798 24.3751Z",
    fill: "#000001"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67744 10.0001C3.02262 9.40219 3.78711 9.19735 4.38497 9.54252L11.9627 13.9175C12.5606 14.2627 12.7654 15.0272 12.4202 15.6251C12.0751 16.2229 11.3106 16.4278 10.7127 16.0826L3.13497 11.7076C2.53711 11.3624 2.33226 10.5979 2.67744 10.0001Z",
    fill: "#000001"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3752 27.5787C24.9731 27.2335 25.7376 27.4384 26.0827 28.0363L30.4577 35.614C30.8029 36.2118 30.5981 36.9763 30.0002 37.3215C29.4023 37.6667 28.6379 37.4618 28.2927 36.864L23.9177 29.2863C23.5725 28.6884 23.7773 27.9239 24.3752 27.5787Z",
    fill: "#000001"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.67836C10.5981 2.33318 11.3626 2.53802 11.7077 3.13589L16.0827 10.7136C16.4279 11.3115 16.2231 12.076 15.6252 12.4211C15.0273 12.7663 14.2629 12.5615 13.9177 11.9636L9.54268 4.38589C9.1975 3.78802 9.40234 3.02354 10.0002 2.67836Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2632_34302)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLight40);
export default __webpack_public_path__ + "static/media/spinner-light-40.751e5ddf0ec3d9f31d2a7eb5d12579db.svg";
export { ForwardRef as ReactComponent };